export type GarmentModel = "3000" | "64000" | "112r" | "gc102";

export type GarmentOption = {
  model: GarmentModel;
  kind: "tee" | "cap";
  color: string;
  label: string;
  hex: string;
  image: string;
};

const palette: Record<GarmentModel, Array<[string, string, string]>> = {
  "3000": [
    ["black", "Black", "#171717"], ["white", "White", "#f5f5f2"],
    ["off_white", "Off white", "#e9e3d6"], ["natural", "Natural", "#dfd2b6"],
    ["sand", "Sand", "#caba9f"], ["charcoal", "Charcoal", "#4c4d4c"],
    ["navy", "Navy", "#172a45"], ["military_green", "Military green", "#4e5943"],
    ["forest_green", "Forest green", "#183e31"], ["cherry_red", "Cherry red", "#a92335"],
    ["maroon", "Maroon", "#64293a"], ["royal", "Royal blue", "#244d9e"],
    ["light_blue", "Light blue", "#a9c7d8"], ["light_pink", "Light pink", "#e7bec4"],
    ["orange", "Orange", "#d9672d"], ["gold", "Gold", "#e0ad2f"],
    ["purple", "Purple", "#5b3e83"], ["sage", "Sage", "#8b9b80"],
  ],
  "64000": [
    ["black", "Black", "#171717"], ["white", "White", "#f5f5f2"],
    ["off_white", "Off white", "#e9e3d6"], ["natural", "Natural", "#dfd2b6"],
    ["sand", "Sand", "#caba9f"], ["charcoal", "Charcoal", "#4c4d4c"],
    ["navy", "Navy", "#172a45"], ["heather_navy", "Heather navy", "#3e5367"],
    ["military_green", "Military green", "#4e5943"], ["forest", "Forest", "#183e31"],
    ["dark_chocolate", "Dark chocolate", "#49382f"], ["coral_silk", "Coral silk", "#d97d73"],
    ["cherry_red", "Cherry red", "#a92335"], ["maroon", "Maroon", "#64293a"],
    ["royal", "Royal blue", "#244d9e"], ["stone_blue", "Stone blue", "#59788a"],
    ["pistachio", "Pistachio", "#aac49a"], ["gold", "Gold", "#e0ad2f"],
  ],
  "gc102": [
    ["black", "Black", "#171717"], ["stone", "Stone", "#b7aa91"],
    ["espresso", "Espresso", "#49352d"], ["terracotta", "Terracotta", "#a9533c"],
    ["spruce_green", "Spruce green", "#2e564e"], ["midnight_blue", "Midnight blue", "#172a45"],
    ["caribbean_blue", "Caribbean blue", "#16859b"], ["royal", "Royal blue", "#244d9e"],
    ["nautical_red", "Nautical red", "#a62835"], ["hot_pink", "Hot pink", "#d95383"],
    ["grape", "Grape", "#5d3c74"], ["wild_plum", "Wild plum", "#713d54"],
  ],
  "112r": [
    ["black", "Black", "#171717"], ["black_white", "Black / white", "#242424"],
    ["cream", "Cream", "#e6d5b7"], ["charcoal", "Charcoal", "#505050"],
    ["charcoal_white", "Charcoal / white", "#555a5c"], ["coffee", "Coffee", "#5a4132"],
    ["dark_green", "Dark green", "#26493c"], ["heather_grey_black", "Heather grey / black", "#858783"],
    ["khaki_black_cmb", "Khaki / black", "#9e8c69"], ["loden", "Loden", "#596149"],
    ["navy", "Navy", "#172a45"], ["navy_white", "Navy / white", "#203752"],
    ["orange_black", "Orange / black", "#bd5c2b"], ["red_white", "Red / white", "#a62835"],
    ["royal_white", "Royal / white", "#27559c"], ["white_black", "White / black", "#eceae4"],
    ["maroon_white", "Maroon / white", "#64293a"], ["smoke_blue", "Smoke blue", "#617c87"],
  ],
};

export const garments: GarmentOption[] = (Object.keys(palette) as GarmentModel[]).flatMap((model) =>
  palette[model].map(([color, label, hex]) => ({
    model,
    kind: model === "3000" || model === "64000" ? "tee" : "cap",
    color,
    label,
    hex,
    image: `/garments/${model}/${model}_${color}_front.jpg`,
  })),
);

export const garmentById = (model: string, color: string) =>
  garments.find((item) => item.model === model && item.color === color);

export const paletteForPrompt = Object.fromEntries(
  (Object.keys(palette) as GarmentModel[]).map((model) => [
    model,
    palette[model].map(([id, label]) => ({ id, label })),
  ]),
);
